import Vue from 'vue';
import bugsnag from '@bugsnag/js';
import bugsnagVue from '@bugsnag/plugin-vue';

const options = {
  apiKey: process.env.VUE_APP_BUGSNAG_API_KEY || '36b1a13d6e6b5c1bdb63cca516e7f964',
  releaseStage: 'DEV',
  notifyReleaseStages: [
    'PRO',
    'PRE',
    'INT',
  ],
  appVersion: process.env.VUE_APP_BCUBE_CMS_VERSION,
};

const bugsnagClient = bugsnag(options).use(bugsnagVue, Vue);
export default bugsnagClient;
